import { render, staticRenderFns } from "./OrgsDialog.vue?vue&type=template&id=62d08926&"
import script from "./OrgsDialog.vue?vue&type=script&lang=js&"
export * from "./OrgsDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports